import { render, staticRenderFns } from "./PolicyInclusions.vue?vue&type=template&id=78bec462"
import script from "./PolicyInclusions.vue?vue&type=script&lang=js"
export * from "./PolicyInclusions.vue?vue&type=script&lang=js"
import style0 from "./PolicyInclusions.vue?vue&type=style&index=0&id=78bec462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
